// Errors in the browser used to vanish with the page: nothing recorded them, so a user's "white
// page" could not be traced to a cause. They go to the API, which logs them next to its own.

const API_URL = process.env.REACT_APP_URL || "";
// A page that keeps failing would otherwise flood the log.
const MAX_REPORTS_PER_PAGE = 5;
let reported = 0;

export function reportClientError(error: unknown, componentStack?: string): void {
  if (reported >= MAX_REPORTS_PER_PAGE) return;
  reported++;
  const e = (error ?? {}) as { name?: string; message?: string; stack?: string };
  const body = JSON.stringify({
    message: `${e.name ? `${e.name}: ` : ""}${e.message ?? String(error)}`.slice(0, 1000),
    stack: (e.stack ?? "").slice(0, 4000),
    componentStack: componentStack?.slice(0, 2000),
    url: window.location.href,
    userAgent: navigator.userAgent,
  });
  try {
    // keepalive: the report still goes out when the page reloads right after the error.
    fetch(`${API_URL}/api/ClientErrors`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body,
      keepalive: true,
    }).catch(() => undefined);
  } catch {
    // no fetch (very old browser) - nothing to report with
  }
}

/** Errors outside React's render, e.g. in event handlers and promises. */
export function installClientErrorReporting(): void {
  window.addEventListener("error", (event) => reportClientError(event.error ?? event.message));
  window.addEventListener("unhandledrejection", (event) => reportClientError(event.reason));
}
